export default new class Otp {
    constructor() {
        this.init();
    }

    init() {

        const otp_length = 4;
        const element = document.getElementById('OTPInput');

        if(null == element) {
            return;
        }

        while(element.firstChild){
            element.removeChild(element.firstChild);
        }

        for (let i = 0; i < otp_length; i++) {
            let inputField = document.createElement('input'); // Creates a new input element
            inputField.className = "";
            inputField.setAttribute("type", "tel");
            // Do individual OTP input styling here;
            inputField.style.cssText = "color: transparent; text-shadow: 0 0 0 gray;"; // Input field text styling. This css hides the text caret
            inputField.id = 'otp-field' + i; // Don't remove
            inputField.maxLength = 1; // Sets individual field length to 1 char
            element.appendChild(inputField); // Adds the input field to the parent div (OTPInput)
        }

        /*  This is for switching back and forth the input box for user experience */
        const inputs = document.querySelectorAll('#OTPInput > *[id]');

        for (let i = 0; i < inputs.length; i++) {

            inputs[i].addEventListener('keydown', function(event) {
                if (event.key === "Backspace") {
                    if (inputs[i].value == '') {
                        if (i != 0) {
                            inputs[i - 1].focus();
                        }
                    } else {
                        inputs[i].value = '';
                    }
                } else if (event.key === "ArrowLeft" && i !== 0) {
                    inputs[i - 1].focus();
                } else if (event.key === "ArrowRight" && i !== inputs.length - 1) {
                    inputs[i + 1].focus();
                } else if (event.key != "ArrowLeft" && event.key != "ArrowRight") {
                    inputs[i].setAttribute("type", "tel");
                    inputs[i].value = ''; // Bug Fix: allow user to change a random otp digit after pressing it
                }

            });

            inputs[i].addEventListener('input', function() {
                let compiledOtp = '';
                inputs.forEach((e) => {
                    compiledOtp += e.value;
                });

                if(compiledOtp.length == otp_length) {
                    inputs.forEach((e) => e.blur());
                    document.getElementById('otp').value = compiledOtp;
                    document.getElementById('confirmation').click();
                }     
                
                if (i === inputs.length - 1 && inputs[i].value !== '') {
                    return true;
                } else if (inputs[i].value !== '') {
                    inputs[i + 1].focus();
                }

                
            });
        }
    }
}();